import React, { useState, useEffect } from "react";
import { Autocomplete, TextField, Box, IconButton } from "@mui/material";
import CachedIcon from "@mui/icons-material/Cached";
import LinkIcon from "@mui/icons-material/Link";
import { UseProductSize } from "./UseProductSize";

export default function SizeAutoComplete(props) {
  const { getAllProductSizeList } = UseProductSize();
  const [selectedSize, setSelectedSize] = React.useState();
  const [productSizeRes, setProductSizeRes] = React.useState();

  useEffect(() => {
    getAllProductSizeList((sizes) => {
      setProductSizeRes(sizes);
    });
  }, []);

  useEffect(() => {
    if (productSizeRes) {
      setSelectedSize(
        productSizeRes.sizes.find((m) => m.id == props.selectedSizeID)
      );
    }
  }, [productSizeRes, props.selectedSizeID]);
  useEffect(() => {
    if (selectedSize) {
      props.setter({
        ...props.lvl2State,
        sizeID: selectedSize.id,
      });
    }
  }, [selectedSize]);

  return productSizeRes ? (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <Autocomplete
        disablePortal
        id="combo-box-demo"
        value={selectedSize ? selectedSize : ""}
        options={productSizeRes.sizes ? productSizeRes.sizes : []}
        getOptionLabel={(sizes) => (sizes.title ? sizes.title : "")}
        isOptionEqualToValue={(option, value) => option.value === value.value}
        renderInput={(params) => <TextField {...params} label="سایز" />}
        renderOption={(props, option) => {
          return (
            <li {...props} key={option.id}>
              {option.title ? option.title : ""}
            </li>
          );
        }}
        onChange={(evt, newValue) => {
          if (newValue) {
            setSelectedSize(newValue);
          } else {
            setSelectedSize();
            props.setter({
              ...props.lvl2State,
              sizeID: 0,
            });
          }
        }}
        fullWidth
        size="small"
      />
      <IconButton
        sx={{ p: 0, m: 1 }}
        onClick={() => {
          getAllProductSizeList((sizes) => {
            setProductSizeRes(sizes);
          });
        }}
      >
        <CachedIcon fontSize="small" />
      </IconButton>
      <IconButton sx={{ p: 0 }} href="/productsize" target="_blank">
        <LinkIcon fontSize="small" />
      </IconButton>
    </Box>
  ) : (
    ""
  );
}
